import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { getOsType } from "@utils/functions";

interface IButton {
  padding: string;
}
const ButtonContainer = styled.button<IButton>(({ theme, padding }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "1.6rem",
  lineHeight: "2rem",
  padding: padding,
  color: theme.color.dark_gray,
}));

const TitleContainer = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
});

type Props = {
  title: string;
  route?: string;
  padding?: string;
  render?: () => React.ReactNode;
  externalLink?: string;
  state?: any;
};

const MenuButton = ({
  title,
  route,
  padding = "0",
  render,
  externalLink,
  state,
}: Props) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const navigateMenu = () => {
    const osType = getOsType();

    if (externalLink) {
      if (osType === "android") {
        window.android.openBrowser(externalLink);
      } else if (osType === 'ios') {
        window.webkit.messageHandlers.openBrowser.postMessage(externalLink);
      } else {
        window.open(externalLink, "_blank");
      }
    } else if (route) {
      if (state) {
        navigate(route, {
          state,
        });
      } else {
        navigate(route);
      }
    }
  };

  return (
    <ButtonContainer onClick={navigateMenu} padding={padding}>
      <TitleContainer>
        {title}
        {render && render()}
      </TitleContainer>
      <Image src={theme.image.arrow_right.default} width="2rem" height="2rem" />
    </ButtonContainer>
  );
};

export default MenuButton;
